import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  header: {
    display: 'flex',
    marginBottom: theme.spacing(2)
  },
  label: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 10,
    paddingBottom: 0,
    // Reskin: the same sentence-case label as the inputs (doubled class outranks the uppercase formLabel type).
    ...reskinStyles(theme, {
      '&&': { textTransform: 'none', fontWeight: 400, fontSize: 12, color: theme.colors.text_secondary }
    })
  },
  container: {
    height: 70
  },
  disabled: {
    opacity: 0.4
  },
  labelNextToText: {
    justifyContent: 'start',
    gap: theme.spacing(1)
  }
});

export default makeStyles(styles);
